import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function getStatusClass(status) {
  if (status === "Released") return "status-released";
  if (status === "In Production") return "status-production";
  return "status-development";
}

export default function ProjectCard({ project, index = 0, large = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.08 }}
    >
      <Link
        to={`/projects/${project.slug}`}
        data-testid={`project-card-${project.slug}`}
        className={`project-card group relative block overflow-hidden rounded-none border border-white/[0.06] ${
          large ? "aspect-[16/10]" : "aspect-[3/4]"
        }`}
      >
        <img
          src={project.poster_image}
          alt={project.title}
          className="project-card-img absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="project-card-overlay absolute inset-0" />

        {/* Top corner marker */}
        <div className="absolute top-0 right-0 p-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <div className="w-8 h-8 border-t border-r border-white/30" />
        </div>

        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 z-10">
          <div className="flex items-center gap-3 mb-3">
            <span className={`text-[9px] uppercase tracking-[0.2em] font-bold px-2.5 py-1 border rounded-none ${getStatusClass(project.status)}`}>
              {project.status}
            </span>
            <span className="text-[9px] uppercase tracking-[0.2em] font-bold text-[#71717A]">
              {project.genre}
            </span>
          </div>
          <h3 className="font-['Syne'] text-lg sm:text-xl md:text-2xl font-bold text-white tracking-tight group-hover:text-[#38BDF8] transition-colors duration-500">
            {project.title}
          </h3>
          {large && project.synopsis && (
            <p className="mt-3 text-sm text-[#A1A1AA] line-clamp-2 max-w-lg leading-relaxed">
              {project.synopsis}
            </p>
          )}

          {/* Hover reveal line */}
          <div className="mt-4 h-px bg-white/0 group-hover:bg-white/20 transition-all duration-700 w-0 group-hover:w-full" />
        </div>
      </Link>
    </motion.div>
  );
}
